import React, { useState, useRef, useEffect, useContext } from 'react';
import WpAPI from '../../WpApi'
import { useHistory } from 'react-router-dom';
import { useDispatch, ReactReduxContext } from 'react-redux';
import { 
    login as loginAction,
    userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction,
    setContextMenu,
    updateUser,
    setMembershipData
} from '../../services/actions/actions';
import { DASHBOARD_LINK, FORGET_LINK, MEMBERSHIP, POPUP_TYPES, PAID_SERVICES, EDITOR_ALL_INONE_LINK, APP_DOMAIN, COOKIE_DOMAIN, COVERLETTER_EXPERIENCE, QUICK_EDITOR, TP_REVIEW_URL } from '../../constants/constants';
import { Redirect } from 'react-router';
import { usePopup } from '../../context/PopupContext';
import downloadResume from '../../downloadResume';
import { decryptData, removeBodyScroll } from '../../helper';
// import { identify as FullStoryIdentify } from '@fullstory/browser';
import { useUser } from '../../context/UserContext';
import Cookies from 'js-cookie';
import { useCoverLetter } from '../../context/CoverLetterContext';

const LoginForm = (props) => {
    const { store } = useContext(ReactReduxContext);
    const [msg, setmsg] = useState('')
    const [email, setemail] = useState('')
    const [password, setpassword] = useState('')
    const [forgetpswd, setforgetpswd] = useState(false);
    const [viewPassword, setViewPassword] = useState(false);
    const [loader, setLoader] = useState({download: false, save: false, share: false, print: false});
    const dispatch = useDispatch();
    const history = useHistory();
    const popupbox = usePopup();
    const type = (window.location.pathname == DASHBOARD_LINK ? 'list' : 'currentResume');
    const entityType = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume");
    const entityName = (entityType == 'resume' ? 'Resume' : 'Cover Letter'); 
    const {
        checkMembership,
        plan,
        user
      } = useUser();

    
      const { login_action_initiated, } = useCoverLetter();
      useEffect(() => {
        login_action_initiated && submitForm(document.getElementById('submit_button'));
    }, [login_action_initiated]);

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    useEffect(() => {
        if(localStorage.getItem('loginError')){
            const loginError = decryptData(localStorage.getItem('loginError'))
            localStorage.removeItem('loginError')
            setmsg(loginError.msg)
        }
    }, [localStorage.getItem('loginError')])

    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
    })

    const submitForm = (e) => {
        let target = (e && e.hasOwnProperty('target')) ? e.target : e
        target && (target.innerHTML = "Logging in" )
        dispatch(loginAction({
            user: email,
            password: password
        })).then(res => {
            WpAPI.linklocalResumeToUser()
            // update user and memberhip data afer a successful signup
            updateStateUserAndMembership()
            return res
        // }).then(res => {
        //     WpAPI.linkLocalCoverLetterToUser(dispatch).then(resp => {
        //         postLoginHandlers(res, target)
        //     })
        //     return res
        }).then(res => WpAPI.fetchActiveResume(dispatch, () => {
            postLoginHandlers(res, target)
            /*
            if(res.user?.track_firstlogin){
                if(res.user.track_firstlogin == 'yes' && res.user.rb_firstlogin == 'yes'){
                    let date = new Date().toJSON();
                    ga4Track('app_registered_user_first_login', 'RT App', `Registered User: First Login, Path:${window.location.pathname}, Email:${email}, Date:${date}`);
                }
            }
            if (props.hasOwnProperty('type') && props.type === 'popup') {
                const dasboardTab = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume");
                // save resume if the dashboard is `resume`
                if(dasboardTab == "resume") WpAPI.saveState(store.getState(), true, false)
                gaTrack('RT App', `Editor`, `Logged in through Popup`);
                ga4Track('app_editor_save_popup_user_logs_in', 'RT App', 'Logged in through Popup');
                ga4Track('app_editor_login_popup_login', 'RT App', 'Login Popup: Logged in through popup');
                if(window.location.pathname == '/'){
                    WpAPI.loadResumesInDashboard(props.setResumes);
                    setTimeout(() => {
                        triggerLastAction();
                    }, 300);
                }else{
                    triggerLastAction();
                }
                props.setShowLoginPopUp(false);
                if(ENV == 'prod') fullStoryIdentify(email);
                target.innerHTML = "Log In"
            }
            if (props.hasOwnProperty('type') && props.type == 'page') {
                checkMembershipAction();
                ga4Track('app_editor_login_logged_in', 'RT App', 'Login Page: Logged in'); 
                if(ENV == 'prod') fullStoryIdentify(email);
                window.location.href = '/';
            }
            ga4Track('app_all_login_points_user_logins', 'RT App', 'User Logs In');
            */
        })).catch((e) => {
            setmsg(e)
            gaTrack('RT App', `Login Page`, 'User Log In Error');
            ga4Track('app_login_user_logs_in', 'RT App', 'User Log In Error');
            props?.type == 'coverletter_page' || (target.innerHTML =  "Log In")
            props?.type == 'coverletter_page' && props.loginInitiationInterrupted();
        })
    }

    const postLoginHandlers = (res, target) => {
        // call the tracking events post login/signup
        trackingEventsHandler(res)
        // save the resume/coverletter data post login/signup
        saveHandler()
        // load the resumes/coverletters post login/signup
        dataReloadHandler()
        // trigger the last clicked action post login/signup
        lastActionHandler()
        // final actions post login/signup
        finalActionsHandler(target)
    }

    const updateStateUserAndMembership = () => {
        WpAPI.isLoggedIn() && WpAPI.getLoginUserInfo().then(res => {
            dispatch(updateUser(res.data.user))
            const currentAccount = {
                plan: 'pro', 
                lastsync: Math.floor(Date.now() / 1000), 
                has_plan: true,
                plan_has_trial: false,
                plan_status: 'active'
            }
            dispatch(setMembershipData(currentAccount));
        })
    }

    const trackingEventsHandler = (res) => {
        if(res.user?.track_firstlogin){
            if(res.user.track_firstlogin == 'yes' && res.user.rb_firstlogin == 'yes'){
                let date = new Date().toJSON();
                ga4Track('app_registered_user_first_login', 
                    'RB App', 
                    `Registered User: First Login, Path:${window.location.pathname}, 
                    Email:${res.user.email}, 
                    Date:${date}`
                );
            }
        }
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            gaTrack('RT App', `Editor`, `Logged in through Popup`);
            ga4Track('app_editor_save_popup_user_logs_in', 'RT App', 'Logged in through Popup');
            ga4Track('app_editor_login_popup_login', 'RT App', 'Login Popup: Logged in through popup');
        }else if (props.hasOwnProperty('type') && props.type === 'page') {
            ga4Track('app_editor_login_logged_in', 'RT App', 'Login Page: Logged in');
        }else if (props.hasOwnProperty('type') && props.type === 'coverletter_page') {
            ga4Track('app_coverletter_login_logged_in', 'RT App', 'CoverLetter Login Page: Logged in');
        }
        ga4Track('app_all_login_points_user_logins', 'RT App', 'User Logs In');

        // send data to the FullStory
        if(ENV == 'prod') fullStoryIdentify(res.user.email);
    }

    const saveHandler = () => {
        //const dashboardTab = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(entityType == 'resume')
                WpAPI.saveState(store.getState(), true, false)
        }
    }

    const dataReloadHandler = () => {
        //const dashboardTab = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(window.location.pathname == '/'){
                if(entityType == 'resume')
                    WpAPI.loadResumesInDashboard(props.setEntities)
                else if(entityType == 'coverletter')
                    WpAPI.loadCoverLettersInDashboard(props.setEntities)
            }
        }
    }

    const lastActionHandler = () => {
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(window.location.pathname == '/'){
                setTimeout(() => {
                    triggerLastAction();
                }, 300);
            }else{
                triggerLastAction();
            }
        }
    }

    const finalActionsHandler = (target) => {
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            props.setShowLoginPopUp(false)
            target.innerHTML = "Log In"
        }else if (props.hasOwnProperty('type') && props.type === 'page') {
            checkMembershipAction()
            window.location.href = '/'
        }else if (props.hasOwnProperty('type') && props.type === 'coverletter_page') {
            // checkMembershipAction()
            // window.location.href = '/coverletter/finalize'
            // props.loginInitiationCompleted();
            props.loginSuccessfullyCompleted()
        }
    }

    const triggerLastAction = () => {
        const clickAction = (localStorage.getItem('clickAction') && typeof localStorage.getItem('clickAction') != 'undefined' ? localStorage.getItem('clickAction') : '');
        switch(clickAction){
            case 'download':
                checkMembershipAction(download);
                break;
            case 'print':
                checkMembershipAction(print);
                break;
            case 'share':
                checkMembershipAction(share);
                break;
            case 'saveandnext':
                checkMembershipAction(saveAndNext);
                break;
            case 'help':
                help();
                break;
            default:
                checkMembershipAction();
                //do nothing..
                break;
        }
    }

    const enter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            props?.loginInitiated && props.loginInitiated();
            submitForm(document.getElementById('submit_button'));
        }
    }

    const checkMembershipAction = (callback = false, params = false, forcechange = true) => {
        if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
            const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
            if(localStorage.getItem('clickAction') && !downloadOnAllinonePageLoad) localStorage.removeItem('clickAction');
        }, forcechange);
    }

    const saveAndNext = () => {
        history.push(QUICK_EDITOR);
        // if (PAID_SERVICES) {
        //     if (store.getState().plan == 'pro') {
        //         history.push(EDITOR_ALL_INONE_LINK);
        //     } else {
        //         history.push(MEMBERSHIP);
        //     }
        // } else {
        //     history.push(EDITOR_ALL_INONE_LINK);
        // }
    }

    const help = () => {
        window.location.href = `${APP_DOMAIN}/${DASHBOARD_LINK}`
    }

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction(store.getState().resume, type)).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && store.getState().plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && store.getState().plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RT App', el)
            }
        })
    }

    const share = () => {
        if(PAID_SERVICES){
            if(store.getState().plan == 'pro'){
                popupbox.show('share', null, () => {
                    //do nothing..
                }, {resume: {...store.getState().resume, id: store.getState().currentResume}, user: store.getState().user, type: type})
            }else{
                history.push(MEMBERSHIP);
            }
        }else{
            popupbox.show('share', null, () => {
                //do nothing..
            }, {resume: {...store.getState().resume, id: store.getState().currentResume}, user: store.getState().user, type: type})
        }
        userCompletesSectionsDownloadsPrintsOrShares();
    }

    const download = () => {
        // if(PAID_SERVICES){
        //     store.getState().plan == 'pro' 
        //     ? popupbox.show('download', null, () => downloadResumeHandler()) 
        //     : history.push(MEMBERSHIP);
        // }else{
        //     popupbox.show('download', null, () => downloadResumeHandler()) 
        // }
        /**
         * #775: Any logged in users can download the resume in the text format. 
         * Action: Removed the above code snippet having PAID_SERVICES and plan check.
         * Date: 2023-07-21
         */
        //This is coming from Quick Editor Traditional page. When user clicks the download button.
        const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
        if(store.getState().plan == 'pro' && downloadOnAllinonePageLoad){
            history.push(QUICK_EDITOR);
        }else{
            popupbox.show('download', null, () => {
                downloadResumeHandler();
                userCompletesSectionsDownloadsPrintsOrShares();
                localStorage.getItem('downloadOnAllinonePageLoad') && localStorage.removeItem('downloadOnAllinonePageLoad');
            }, {plan: store.getState().plan, entity:{type: entityType, name: entityName }, referrer:'login'});
        }
        //popupbox.show('download', null, () => downloadResumeHandler(), {plan: store.getState().plan});
        //userCompletesSectionsDownloadsPrintsOrShares();
    }

    const downloadResumeHandler = () => {
        downloadResume(store.getState(), user, () => { 
            popupbox.close('download');
            popupbox.show('askfor_trustpilot_review', null, () => {
                window.open( TP_REVIEW_URL, '_blank');
            });
            // popupbox.show('downloadcompletionbox', null, () => {
            //     window.location.href = `${APP_DOMAIN}${COVERLETTER_EXPERIENCE}`;
            // });
        }, store.getState().downloadFormat, {type: entityType, name: entityName});
    }

    const print = () => {
        // if (!navigator.onLine) {
        //     alert("You seem to be offline. Please try again later.");
        //     return false;
        // }else{
            if(PAID_SERVICES){
                if(store.getState().plan == 'pro'){
                    dispatch(setContextMenu({context_menu: false}));
                    window.print()
                }
                else history.push(MEMBERSHIP);
            }else window.print();
        //}
        userCompletesSectionsDownloadsPrintsOrShares();
        const ec = (window.innerWidth < 769 ? 'app_quick_editor_print_mobile' : 'app_quick_editor_print');
        const el = (window.innerWidth < 769 ? 'Mobile Print' : 'Print');
        gaTrack('RT App', `Quick Editor`, el);
        ga4Track(ec, 'RT App', el);
    }

    const fullStoryIdentify = (email) => {
        let uId = email;
        let displayName = email;
        // FullStoryIdentify(uId, {
        //   displayName: displayName
        // });
    }

    const otherActionsHandler = () => {
        const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
        if(localStorage.getItem('clickAction') && !downloadOnAllinonePageLoad) localStorage.removeItem('clickAction');
    }

    if (props.loginHash) {
        gaTrack('RT App', `Login Page`, 'User Logged In');
        ga4Track('app_login_user_logs_in', 'RT App', 'User Logged In');

        // Stopping to go to membership page. Comment out the line below to rever the change
        return <Redirect to={DASHBOARD_LINK} />
    }

    if (forgetpswd) {
        props.type === 'popup' && props.setShowLoginPopUp(false);
        return <Redirect to={FORGET_LINK} />
    } 

    return (
        <div className="login-form">
            <div className="form">
                <div className="field-wrap">
                    {msg && <div className="error" style={{marginBottom: "5px"}}>{msg}</div>}
                    <label htmlFor="Email" className="label">Email</label>
                    <input type="email" placeholder="Email Address" value={email}
                        onChange={e => setemail(e.target.value)}
                        onKeyDown={e => enter(e)}
                        className="form-input borderaccent" />
                </div>
                <div className="field-wrap">
                    <label htmlFor="Password" className="label">Password</label>
                    <div className="password-wrap">
                        <input type={viewPassword ? `text` : `password`} placeholder="Password" value={password}
                        onChange={e => setpassword(e.target.value)}
                        onKeyDown={e => enter(e)}
                        className="form-input borderaccent" />
                        <span className="password-view" onClick={() => {
                            setViewPassword(!viewPassword);
                        }}><i className={viewPassword ? 'icon-eye-slash' : 'icon-eye'}></i></span>
                    </div>
                    {props?.type !== 'coverletter_page' && <div className="forget-link">
                        <a
                            onClick={
                                (e) => {
                                    setforgetpswd(true);
                                }
                            }>Forgot Password?</a>
                    </div>}

                </div>
                {props?.type !== 'coverletter_page' && <div className="field-wrap align-right">
                    <button className="button black" id='submit_button' onClick={
                        e => {
                            if (props.hasOwnProperty('type') && props.type === 'popup') {
                                //Set redirect_to here in case user Sign up through Popup
                                if(typeof localStorage.getItem('downloadOnAllinonePageLoad') != 'undefined' && !localStorage.getItem('downloadOnAllinonePageLoad'))
                                    WpAPI.setRedirectCookie(window.location.pathname);
                            }
                            removeBodyScroll();
                            submitForm(e);
                            e.preventDefault()
                        }
                    }>Log In</button>
                </div>}
            </div>
        </div>
    );
}
export default LoginForm;